import { forwardRef, HTMLAttributes } from "react"
import type * as Polymorphic from "@radix-ui/react-polymorphic"
import { styled, StyleProps, CSSFn, callCSSFn } from "../styles"

type SectionProps = HTMLAttributes<HTMLElement> & {
  css?: CSSFn
  size?: `1` | `2` | `3`
}
type SectionComponent = Polymorphic.ForwardRefComponent<typeof StyledSection, SectionProps>

export const Section = forwardRef((props, forwardedRef) => (
  <StyledSection {...props} ref={forwardedRef} />
)) as SectionComponent

const StyledSection = styled.section<HTMLAttributes<HTMLElement>>((props: StyleProps) => ({
  boxSizing: `border-box`,
  flexShrink: 0,
  "&::before": {
    boxSizing: `border-box`,
  },
  "&::after": {
    boxSizing: `border-box`,
  },
  padding: props.theme.spacing(0, 0, 4, 0),
  ...callCSSFn(props),
}))
